// extracted by mini-css-extract-plugin
export default {"emptyBox":"brands_emptyBox__mH7hR"};